import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getShapeFormConfig } from "../utils/refs.js";
// biome-ignore lint/nursery/noImportCycles: Intentional cycle (use-preview-content -> default-widgets -> ShapeField -> use-preview-content)
import { getContentPreview } from "../widgets/default-widgets.js";
import { useForms, usePreviews } from "./use-form-store.js";
/**
 * Resolves preview content for collapsible headers (array items, discriminated unions).
 *
 * Resolution order:
 * 1. Variant shape config preview (for discriminated unions)
 * 2. Config preview (from parent items config)
 * 3. Default text preview (getContentPreview for objects)
 * 4. Fallback text
 */
export function usePreviewContent({ value, schema, path, variantRef, config, fallbackText }) {
    const forms = useForms();
    const previews = usePreviews();
    return useMemo(() => {
        // 1. Check variant shape config preview
        let previewName;
        if (variantRef) {
            const variantConfig = getShapeFormConfig(forms, variantRef);
            previewName = variantConfig?.preview;
        }
        // 2. Check config preview
        if (!previewName) {
            previewName = config?.preview;
        }
        // 3. Look up preview component
        if (previewName && previews?.[previewName]) {
            const PreviewComponent = previews[previewName];
            return _jsx(PreviewComponent, { value: value, schema: schema, path: path });
        }
        // 4. Default text preview for objects
        if (value && typeof value === 'object' && schema.type === 'object') {
            const text = getContentPreview(value, schema);
            if (text)
                return text;
        }
        return fallbackText ?? null;
    }, [variantRef, config, previews, forms, value, schema, path, fallbackText]);
}
